import { useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { Currency } from "../../../../lib/components/Currency";
import { SubmitButton, CancelButton } from "../../shared";
import "../../Commissions.css";

export function AdjustModal({
  target,
  onCancel,
  onSave,
  isSubmitting = false,
}) {
  const [amount, setAmount] = useState(
    String((target.effective ?? 0).toFixed(2)),
  );
  const [reason, setReason] = useState("");
  const parsed = parseFloat(amount);
  const valid = !isNaN(parsed) && reason.trim().length > 0;

  return (
    <Modal show onHide={onCancel} centered className="commission-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">
          Adjust amount — {target.label}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-current-value">
          <span className="text-muted">Current amount</span>
          <span className="fw-semibold">
            <Currency amount={target.effective} />
          </span>
        </div>

        <Form.Group className="mb-3">
          <Form.Label className="field-label">Adjustment Amount</Form.Label>
          <InputGroup>
            <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
              type="number"
              step="0.01"
              defaultValue={0}
              onChange={(e) => setAmount(e.target.value)}
              disabled={isSubmitting}
              autoFocus
            />
          </InputGroup>
        </Form.Group>

        <Form.Group>
          <Form.Label className="field-label">
            Reason <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            maxLength={500}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Why is this amount changing?"
            disabled={isSubmitting}
          />
          <Form.Text className="char-counter">{reason.length}/500</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={onCancel} disabled={isSubmitting} />
        <SubmitButton
          text="Save adjustment"
          color="blue"
          disabled={!valid}
          isSubmitting={isSubmitting}
          onClick={() => onSave(parsed, reason.trim())}
        />
      </Modal.Footer>
    </Modal>
  );
}
